import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var generateStyle = function generateStyle(componentTheme, props) {
  var mq = '@media print';
  return {
    wordbankWrapper: _objectSpread({}, props.blanks.find(function (blank) {
      return blank.answerType === 'wordbank';
    }) && {
      display: 'flex',
      flexWrap: 'wrap',
      border: "".concat(componentTheme.wordbankWrapperBorder, " solid ").concat(componentTheme.wordbankWrapperBorderColor),
      borderRadius: componentTheme.wordbankWrapperBorderRadius,
      backgroundColor: componentTheme.wordbankWrapperColor,
      minHeight: '60px',
      '> div': {
        display: 'flex',
        margin: componentTheme.wordbankWrapperMargin
      }
    }),
    print: _defineProperty({}, mq, {
      display: 'flex',
      flexWrap: 'wrap',
      border: "".concat(componentTheme.printBorder, " solid ").concat(componentTheme.printBorderColor),
      borderRadius: componentTheme.printBorderRadius,
      backgroundColor: componentTheme.printColor,
      minHeight: '60px',
      '> div': {
        margin: componentTheme.printMargin
      }
    })
  };
};
export default generateStyle;